module.exports = __webpack_public_path__ + "static/media/luxurybar3.b515ab7c.jpg";